import styled, { css } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { Container as BaseContainer } from 'builder/components/Container'
import Button from 'builder/components/Button'

export const Title = styled.div`
  ${Typography.XL};
  font-weight: 700;
  color: ${Colors.Blue50};
  margin-bottom: 12px;
  text-align: center;

  ${Media.Phone`
    text-align: left;
    width: 100%;
  `}
`

export const Subtitle = styled.div`
  margin-bottom: 32px;
  max-width: 544px;
  text-align: center;

  ${Media.Phone`
    text-align: left;
    margin-bottom: 24px;
    max-width: 100%;
  `}
`

export const Container = styled(BaseContainer)`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  ${Media.Phone`
    align-items: flex-start;
  `};
`

export const Wrapper = styled.div`
  padding: 42px 0 40px;

  ${Media.Phone`
    padding: 32px 0 36px;
  `};
`

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;
  max-width: 650px;
  width: 100%;

  ${Media.Phone`
    max-width: 100%`}
`

export const SkipButton = styled(Button)`
  color: ${Colors.Blue50};
  background-color: rgba(26, 145, 240, 0.1) !important;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    background-color: rgba(26, 145, 240, 0.3) !important;
  }

  ${Media.Phone`
    width: 100%;
  `}
`

export const ContinueButton = styled(Button)`
  ${Media.Phone`
    width: 100%;
  `}
`

/**
 * Category Blocks
 */

export const CategoryGridContainer = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(3, 1fr);

  ${Media.Phone`
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
  `};
`

export const CategoryChoiceContainer = styled.div<{ selected: boolean }>(({ selected }) => {
  return css`
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    border-radius: 16px;
    border: 2px ${selected ? 'solid' : 'hidden'};
    background-color: ${selected ? Colors.Blue10 : Colors.Neutral5};
    border-color: ${selected ? Colors.Blue50 : ''};
    position: relative;
    height: 145px;
    width: 200px;
    cursor: pointer;

    ${Media.Phone`width: 100%;`};
  `
})

export const InputContainer = styled.div<{ checked: boolean }>(({ checked }) => {
  return css`
    position: absolute;
    width: 18px;
    height: 18px;
    top: 12px;
    right: 12px;
    border-radius: 4px;
    border: 2px ${checked ? Colors.Blue50 : Colors.Neutral30} solid;
    background-color: ${checked ? Colors.Blue50 : ''};
    background-position: center;
    background-image: ${checked ? `url(${require(`images/builder/sign-up/tick.svg`)})` : ''};
  `
})

export const CategoryTitle = styled.span`
  font-weight: 500px;
  font-size: 19px;
  line-height: 22px;
  text-align: center;
  vertical-align: middle;
  letter-spacing: 0%;
`

export const ItemIcon = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 40px;
  height: 40px;
`
